import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import BlogForm, { BLOG_ROUTE, Toast, blogApi, useToast } from "./blogShared";


export default function CreateBlogPage() {
  const navigate = useNavigate();
  const [saving, setSaving] = useState(false);
  const [serverErrors, setServerErrors] = useState(null);
  const [toast, setToast, closeToast] = useToast();

  const handleSubmit = async (fd) => {
    setSaving(true);
    setServerErrors(null);
    try {
      await blogApi.create(fd);
      navigate(BLOG_ROUTE);
    } catch (err) {
      setServerErrors(err.fields);
      setToast({ type: "error", message: err.message });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 p-4 sm:p-8">
      <Toast toast={toast} onClose={closeToast} />
      <div className="mx-auto max-w-4xl">
        <Link to={BLOG_ROUTE} className="text-sm text-gray-500 hover:text-gray-900">
          ← Back to blogs
        </Link>
        <h1 className="mb-6 mt-2 text-2xl font-semibold text-gray-900">Create blog</h1>
        <BlogForm
          saving={saving}
          serverErrors={serverErrors}
          submitLabel="Create blog"
          onSubmit={handleSubmit}
          onCancel={() => navigate(BLOG_ROUTE)}
        />
      </div>
    </div>
  );
}